import React from 'react';
import {useFormGroupsStyles} from '../styles';
import {StyledButtonGroup} from '../../../styled/Containers';
import TextInput from '../../FormElements/TextInput';
import PriceInput from '../../FormElements/PriceInput';
import YearInput from '../../FormElements/YearInput';
import Button from '@material-ui/core/Button';

function CreditCards(props) {
    const {componentData, index, setItemValue, deleteBlock} = props;
    const classes = useFormGroupsStyles();

    const setValue = (key, value) => {
        setItemValue(index, key, value);
    };

    const deleteValue = () => {
        deleteBlock();
    };

    return (
        <>

            <TextInput
                noFormTag={true}
                title="Institution"
                id="institution"
                setValue={setValue}
                value={componentData.institution}
                required={!componentData.institution}
            />

            <YearInput
                noFormTag={true}
                title="Year Account Opened"
                id="year_account_opened"
                setValue={setValue}
                minYears={50}
                value={componentData.year_account_opened}
                required={!componentData.year_account_opened}
            />

            <PriceInput
                noFormTag={true}
                id="credit_card_limit"
                title="Credit Card Limit"
                type="currency"
                value={componentData.credit_card_limit}
                setValue={setValue}
                required={!componentData.credit_card_limit}
            />

            <PriceInput
                noFormTag={true}
                id="outstanding_balance"
                title="Outstanding Balance"
                type="currency"
                value={componentData.outstanding_balance}
                setValue={setValue}
                required={!componentData.outstanding_balance}
            />

            <PriceInput
                noFormTag={true}
                id="monthly_repayment"
                title="Monthly Repayment"
                type="currency"
                value={componentData.monthly_repayment}
                setValue={setValue}
                required={!componentData.monthly_repayment}
            />

            {index !== 0 ? (
                <StyledButtonGroup style={{marginTop:0, marginBottom:'1rem'}}>
                    <div className="flex_left">
                        <Button
                            variant="contained"
                            className="back"
                            color="secondary"
                            onClick={deleteValue}
                            id="deletePropertyBlock"
                        >
                            Delete
                        </Button>
                    </div>
                </StyledButtonGroup>
            ) : null}

        </>
    );
}

export default CreditCards;
